export default "__VITE_ASSET__D903po2V__"